import {FC} from 'react'
import { useIntl } from 'react-intl';

export enum MessageType {
  ERROR = 'ERROR',
  INFO = 'INFO',
  SUCCESS = 'SUCCESS',
  WARNING = 'WARNING'
}

interface Props {
  autoHide?: boolean
  showDelay?: number
  iconClass?: string
  messageType?: MessageType
  message?: string
}

const MessageToast: FC<Props> = ({
  autoHide = true,
  showDelay = 5000,
  iconClass,
  messageType = MessageType.INFO,
  message,
}) => {
  const intl = useIntl()

  const computeContainerClass = (messageType: MessageType) => {
    // let classes = `toast show fade border border border-secondary rounded-2`
    let classes = `toast fade border border border-secondary rounded-2`
    if (messageType === 'ERROR') {
      classes += ` bg-light-danger`
    } else if (messageType === 'INFO') {
      classes += ` bg-light-primary`
    } else if (messageType === 'SUCCESS') {
      classes += ` bg-light-success`
    } else if (messageType === 'WARNING') {
      classes += ` bg-light-warning`
    } else {
      classes += ` bg-light-primary`
    }
    return classes
  }

  const computeIconClass = (iconClass: string | undefined, messageType: MessageType) => {
    let classes = `fs-3 pt-1 bi`
    if (messageType === 'ERROR') {
      classes += ` text-danger`
    } else if (messageType === 'INFO') {
      classes += ` text-primary`
    } else if (messageType === 'SUCCESS') {
      classes += ` text-success`
    } else if (messageType === 'WARNING') {
      classes += ` text-warning`
    } else {
      classes += ` text-primary`
    }

    if (iconClass) {
      classes += ` ${iconClass}`
    } else {
      if (messageType === 'ERROR') {
        classes += ` bi-exclamation-circle`
      } else if (messageType === 'INFO') {
        classes += ` bi-info-circle`
      } else if (messageType === 'SUCCESS') {
        classes += ` bi-check-circle`
      } else if (messageType === 'WARNING') {
        classes += ` bi-exclamation-circle`
      } else {
        classes += ` bi-info-circle`
      }
    }

    return classes
  }

  return (
    <div className='position-fixed top-0 end-0 mt-5 me-5' style={{zIndex: 1000}}>
      <div
        id='#CustomToast'
        className={computeContainerClass(messageType)}
        role='alert hide'
        aria-live='assertive'
        aria-atomic='true'
        data-bs-delay={`${showDelay}`}
        data-bs-autohide={autoHide}
      >
        <div className='toast-body'>
          <div className='d-flex gap-2'>
            <span>
              <i className={computeIconClass(iconClass, messageType)}></i>
            </span>
            <div className='d-flex flex-grow-1 align-items-center'>
              <span className='fw-semibold fs-7'>
                {message || intl.formatMessage({id: 'ERROR.MESSAGE.UNKNOWN'})}
              </span>
            </div>
            <button
              type='button'
              className='btn-close btn-close-secondary btn-close-sm ms-auto'
              data-bs-dismiss='toast'
              aria-label='Close'
            ></button>
          </div>
        </div>
      </div>
    </div>
  )
}

export {MessageToast}
